import { SerializedConstructor } from '@langchain/core/load/serializable';
import { FormControl, FormLabel, Input } from '@mui/joy';

import { PlaygroundSecretInput } from '../../../PlaygroundSecretInput';
import {
  ManifestEditorProps,
  ManifestSecretProps,
  tableVariantLabelClass,
  tableVariantRowClass,
} from '../../Manifest.utils';
import { ManifestDropdown } from '../../ManifestDropdown';

const AZURE_OPENAI_API_VERSIONS = [
  '2025-02-01-preview',
  '2024-01-01-preview',
  '2024-12-01-preview',
  '2024-10-21',
  '2024-10-01-preview',
  '2024-09-01-preview',
  '2024-06-01',
  '2024-02-01',
  '2024-08-01-preview',
  '2024-07-01-preview',
  '2024-05-01-preview',
  '2024-04-01-preview',
  '2024-03-01-preview',
  '2024-02-15-preview',
];

export function ManifestAzureOpenAIEditor(
  props: ManifestEditorProps<SerializedConstructor>
) {
  if (props.variant === 'table' && props.readOnly) {
    return (
      <>
        <div className={tableVariantRowClass}>
          <div className={tableVariantLabelClass}>Deployment Name</div>
          <div>{props.value.kwargs['deployment_name'] ?? ''}</div>
        </div>
        <div className={tableVariantRowClass}>
          <div className={tableVariantLabelClass}>Azure Endpoint</div>
          <div>
            {props.value.kwargs['azure_endpoint'] ??
              props.value.kwargs['openai_api_base'] ??
              ''}
          </div>
        </div>
        <div className={tableVariantRowClass}>
          <div className={tableVariantLabelClass}>API Version</div>
          <div>{props.value.kwargs['openai_api_version'] ?? ''}</div>
        </div>
      </>
    );
  }

  return (
    <>
      <FormControl>
        {props.variant === 'table' ? (
          <div className={tableVariantLabelClass}>Deployment Name</div>
        ) : (
          <FormLabel>Deployment Name</FormLabel>
        )}
        <Input
          type="text"
          value={props.value.kwargs['deployment_name'] ?? ''}
          onChange={(e) => {
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                deployment_name: e.target.value,
              },
            });
          }}
          sx={{ '& input': { boxShadow: 'none !important' } }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Azure Endpoint</FormLabel>
        <Input
          type="text"
          value={
            props.value.kwargs['azure_endpoint'] ??
            props.value.kwargs['openai_api_base'] ??
            ''
          }
          onChange={(e) => {
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                azure_endpoint: e.target.value,
              },
            });
          }}
          sx={{ '& input': { boxShadow: 'none !important' } }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>API Version</FormLabel>
        <ManifestDropdown<string>
          withSearch
          value={props.value.kwargs['openai_api_version'] ?? null}
          onChange={(version) =>
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                openai_api_version: version,
              },
            })
          }
          options={AZURE_OPENAI_API_VERSIONS}
          placeholder="Select OpenAI API version..."
        />
      </FormControl>
    </>
  );
}

export const ManifestSecretAzureOpenAI = (props: ManifestSecretProps) => {
  return (
    <div className="flex flex-col gap-4">
      <PlaygroundSecretInput
        name="AZURE_OPENAI_API_KEY"
        value={props.value['AZURE_OPENAI_API_KEY'] ?? ''}
        onChange={(value) =>
          props.onChange({
            ...props.value,
            ['AZURE_OPENAI_API_KEY']: value,
          })
        }
      />
    </div>
  );
};

// JS uses specific kwargs instead
// show these when specified
export function ManifestJSAzureOpenAIEditor(
  props: ManifestEditorProps<SerializedConstructor>
) {
  if (props.value.kwargs['azure_openai_api_deployment_name'] == null) {
    return null;
  }

  return (
    <>
      <FormControl>
        <FormLabel>Azure Instance Name</FormLabel>
        <Input
          type="text"
          value={props.value.kwargs['azure_openai_api_instance_name'] ?? ''}
          onChange={(e) => {
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                azure_openai_api_instance_name: e.target.value,
              },
            });
          }}
          sx={{ '& input': { boxShadow: 'none !important' } }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Azure Deployment Name</FormLabel>
        <Input
          type="text"
          value={props.value.kwargs['azure_openai_api_deployment_name'] ?? ''}
          onChange={(e) => {
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                azure_openai_api_deployment_name: e.target.value,
              },
            });
          }}
          sx={{ '& input': { boxShadow: 'none !important' } }}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Azure API Version</FormLabel>
        <Input
          type="text"
          value={props.value.kwargs['azure_openai_api_version'] ?? ''}
          onChange={(e) => {
            props.onChange({
              ...props.value,
              kwargs: {
                ...props.value.kwargs,
                azure_openai_api_version: e.target.value,
              },
            });
          }}
          sx={{ '& input': { boxShadow: 'none !important' } }}
        />
      </FormControl>
    </>
  );
}
